import DatePicker from "@/components/DatePicker";
import filesize from "filesize";
import gsap from "gsap";
import oib from "oib.js";

export default class FormCustom {
    constructor() {
        this.initMutationObserver();
        this.initConditionalFields();
        this.initCustomImageUpload();
        this.initCustomFileUpload();
        this.initOibValidation();
        this.initWpCfEvents();
    }

    initMutationObserver() {
        let formCustom = document.querySelectorAll(".js-form-custom");
        if (formCustom.length < 1) {
            return;
        }
        for (let i = 0; i < formCustom.length; i++) {
            const targetNode = formCustom[i].querySelector(".js-repeating-groups");
            if (targetNode === null) {
                return;
            }
            const config = {attributes: false, childList: true, subtree: false};
            const callback = (mutationsList) => {
                const datepicker = new DatePicker();
                this.initConditionalFields();
                this.initCustomImageUpload();
                this.initOibValidation();
            };
            const observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
        }
    }

    initConditionalFields() {
        let conditionalWrapper = document.querySelectorAll(
            ".js-conditional-fields-wrapper",
        );

        if (conditionalWrapper.length < 1) {
            return;
        }

        for (let i = 0; i < conditionalWrapper.length; i++) {
            if (!conditionalWrapper[i].classList.contains("has-conditional-init")) {
                if (conditionalWrapper[i] == null) {
                    return;
                }

                conditionalWrapper[i].classList.add("has-conditional-init");
                const conditionalGroup = conditionalWrapper[i].querySelector(
                    ".js-conditional-fields",
                );

                const inputs = conditionalGroup.querySelectorAll(
                    ".js-conditional-input",
                );

                for (let j = 0; j < inputs.length; j++) {
                    inputs[j].id = inputs[j].getAttribute("id") + "-g-" + (i + 1);
                    if (inputs[j].checked) {
                        let activeGroup = conditionalGroup.querySelector(
                            `[data-value="${inputs[j].value}"]`,
                        );
                        activeGroup.style.display = "block";
                    } else {
                        let inActiveGroup = conditionalGroup.querySelector(
                            `[data-value="${inputs[j].value}"]`,
                        );
                        inActiveGroup.style.display = "none";
                        inActiveGroup.querySelector("input").value = "0";
                    }
                    inputs[j].addEventListener("click", () => {
                        let resetFieldsets = conditionalGroup.querySelectorAll(
                            `[data-value]`,
                        );
                        for (let r = 0; r < resetFieldsets.length; r++) {
                            resetFieldsets[r].style.display = "none";
                            resetFieldsets[r].querySelector("input").value = "0";
                        }
                        if (inputs[j].checked) {
                            let activeGroup = conditionalGroup.querySelector(
                                `[data-value="${inputs[j].value}"]`,
                            );
                            activeGroup.style.display = "block";
                            activeGroup.querySelector("input").value = "";
                        } else {
                            let inActiveGroup = conditionalGroup.querySelector(
                                `[data-value="${inputs[j].value}"]`,
                            );
                            inActiveGroup.style.display = "none";
                            inActiveGroup.querySelector("input").value = "0";
                        }
                    });
                }
                const labels = conditionalGroup.querySelectorAll(
                    ".js-conditional-label",
                );
                for (let l = 0; l < labels.length; l++) {
                    labels[l].setAttribute(
                        "for",
                        labels[l].getAttribute("for") + "-g-" + (i + 1),
                    );
                }
            }
        }
    }

    initCustomImageUpload() {
        let customImageUpload = document.querySelectorAll(
            ".js-custom-image-upload",
        );
        if (customImageUpload.length < 1) {
            return;
        }
        for (let i = 0; i < customImageUpload.length; i++) {
            if (
                !customImageUpload[i].classList.contains("has-custom-image-upload-init")
            ) {
                customImageUpload[i].classList.add("has-custom-image-upload-init");
                let previewURL;
                let uploadTrigger = customImageUpload[i].querySelector(
                    ".js-custom-image-upload-trigger",
                );
                let uploadInput = customImageUpload[i].querySelector(
                    ".js-custom-image-upload-input",
                );
                let imageHolder = customImageUpload[i].querySelector(
                    ".js-custom-image-upload-image-holder",
                );
                let cancelImage = customImageUpload[i].querySelector(
                    ".js-custom-image-upload-cancel",
                );
                uploadTrigger.addEventListener("click", (event) => {
                    event.stopPropagation();
                    uploadInput.click();
                });
                uploadInput.addEventListener("change", () => {
                    if (uploadInput.files.length === 0) {
                        URL.revokeObjectURL(previewURL);
                        uploadInput.value = "";
                        uploadTrigger.classList.remove("is-active");
                        imageHolder.style.display = "none";
                        cancelImage.style.display = "none";
                    } else {
                        let file = uploadInput.files[0];
                        uploadTrigger.classList.add("is-active");
                        previewURL = URL.createObjectURL(file);
                        imageHolder.style.backgroundImage = `url(${previewURL})`;
                        imageHolder.style.display = "block";
                        cancelImage.style.display = "block";
                    }
                });
                cancelImage.addEventListener("click", (event) => {
                    event.cancelBubble = true;
                    URL.revokeObjectURL(previewURL);
                    uploadInput.value = "";
                    uploadTrigger.classList.remove("is-active");
                    imageHolder.style.display = "none";
                    cancelImage.style.display = "none";
                });
            }
        }
    }

    initCustomFileUpload() {
        let customFileUpload = document.querySelectorAll(".js-custom-file-upload");
        if (customFileUpload.length < 1) {
            return;
        }
        for (let i = 0; i < customFileUpload.length; i++) {
            if (
                !customFileUpload[i].classList.contains("has-custom-file-upload-init")
            ) {
                customFileUpload[i].classList.add("has-custom-file-upload-init");
                let fileURL;
                let uploadTrigger = customFileUpload[i].querySelector(
                    ".js-custom-file-upload-trigger",
                );
                let uploadInput = customFileUpload[i].querySelector(
                    ".js-custom-file-upload-input",
                );
                let fileInfo = customFileUpload[i].querySelector(
                    ".js-custom-file-upload-info",
                );
                let fileName = customFileUpload[i].querySelector(
                    ".js-custom-file-upload-name",
                );
                let fileSize = customFileUpload[i].querySelector(
                    ".js-custom-file-upload-size",
                );
                let cancelFile = customFileUpload[i].querySelector(
                    ".js-custom-file-upload-cancel",
                );
                uploadTrigger.addEventListener("click", (event) => {
                    event.stopPropagation();
                    uploadInput.click();
                });
                uploadInput.addEventListener("change", () => {
                    if (uploadInput.files.length === 0) {
                        URL.revokeObjectURL(fileURL);
                        uploadInput.value = "";
                        uploadTrigger.classList.remove("is-active");
                        fileInfo.style.display = "none";
                        cancelFile.style.display = "none";
                    } else {
                        let file = uploadInput.files[0];
                        uploadTrigger.classList.add("is-active");
                        fileName.innerText = file.name;
                        fileSize.innerText = filesize(file.size);
                        fileInfo.style.display = "block";
                        fileURL = URL.createObjectURL(file);
                        cancelFile.style.display = "block";
                    }
                });
                cancelFile.addEventListener("click", (event) => {
                    event.cancelBubble = true;
                    URL.revokeObjectURL(fileURL);
                    uploadInput.value = "";
                    uploadTrigger.classList.remove("is-active");
                    fileInfo.style.display = "none";
                    cancelFile.style.display = "none";
                });
            }
        }
    }

    initOibValidation() {
        let oibValidation = document.querySelectorAll(".js-form-custom-oib");
        if (oibValidation.length < 1) {
            return;
        }
        for (let i = 0; i < oibValidation.length; i++) {
            const submitButton = oibValidation[i].closest(".js-form-custom").querySelector(".js-form-custom-submit");
            const oibValidationMessage = oibValidation[i].closest("fieldset").querySelector(".js-form-custom-oib-validation-message");
            oibValidation[i].addEventListener("blur", () => {
                if (oib.validate(oibValidation[i].value) === true) {
                    submitButton.disabled = false;
                    submitButton.style.opacity = "1";
                    oibValidation[i].classList.remove("wpcf7-not-valid");
                    oibValidationMessage.style.display = "none";
                } else {
                    submitButton.disabled = true;
                    submitButton.style.opacity = "0.5";
                    oibValidation[i].classList.add("wpcf7-not-valid");
                    oibValidationMessage.style.display = "block";
                }
            });
        }
    }

    initWpCfEvents() {
        let wpcfForm = document.querySelectorAll(".wpcf7");
        if (wpcfForm.length < 1) {
            return;
        }
        for (let i = 0; i < wpcfForm.length; i++) {
            let formEl = wpcfForm[i].querySelector("form");
            if (this.isFunction(wpcf7.init)) {
                wpcf7.init(formEl);

            }

            let form = wpcfForm[i].querySelector(".js-form-custom");
            let formSubmit = wpcfForm[i].querySelector(".js-form-custom-submit");
            let formSuccess = wpcfForm[i].querySelector(".js-form-custom-success");
            formSubmit.addEventListener("click", () => {
                formSubmit.classList.add("is-loading");
            });
            wpcfForm[i].addEventListener("wpcf7invalid", () => {
                formSubmit.classList.remove("is-loading");
                let inputList = wpcfForm[i].querySelectorAll(".wpcf7-form-control");
                if (inputList.length < 1) {
                    return;
                }
                for (let i = 0; i < inputList.length; i++) {
                    if (inputList[i].classList.contains("wpcf7-not-valid")) {
                        inputList[i].closest("fieldset").classList.add("has-error");
                    } else {
                        inputList[i].closest("fieldset").classList.remove("has-error");
                    }
                }
            }, false);
            wpcfForm[i].addEventListener("wpcf7spam", () => {
                formSubmit.classList.remove("is-loading");
            }, false);
            wpcfForm[i].addEventListener("wpcf7mailsent", () => {
                formSubmit.classList.remove("is-loading");
                formSuccess.classList.add("is-active");

                gsap.to(form, {
                    autoAlpha: 0,
                    onComplete: () => {
                        gsap.to(form, {
                            css: {
                                height: 0,
                            },
                            onComplete: () => {
                                form.classList.add("is-submited");
                            },
                        });
                    },
                });

                gsap.to(window, {
                    duration: 1.2,
                    scrollTo: {
                        y: formSuccess,
                        offsetY: 100,
                    },
                    ease: "expo.inOut",
                    onComplete: () => {
                    },
                });

            }, false);
            wpcfForm[i].addEventListener("wpcf7mailfailed", () => {
                formSubmit.classList.remove("is-loading");
            }, false);
            wpcfForm[i].addEventListener("wpcf7submit", () => {
                formSubmit.classList.remove("is-loading");
            }, false);
        }
    }

    isFunction(functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
    }
}
